import { BannerableType } from '@/logic/services';
import { FC } from 'react';

import { pxToRem } from '@/theme/typography';
import ImageBoxFuture from '../shared/image-box-future';

const MovieFallbackImg = '/icons/my-booking/old-user-booking-card-empty-icon.svg';

/**
 * The slider shows 5 posters per view from the laptop breakpoint up and 3 below
 * (posters-slider.tsx). next/legacy/image copies this into the preload it emits
 * for the `priority` poster, so preload and <img> resolve to the same URL.
 */
const POSTER_SLIDER_SIZES = '(min-width: 1024px) 20vw, 33vw';

interface PostersSliderItemProps {
  title: string;
  img: string;
  bannerPosterType: BannerableType;
  priority?: boolean;
}

const PostersSliderItem: FC<PostersSliderItemProps> = ({
  title,
  img,
  bannerPosterType,
  priority = false,
}) => {
  return (
    <ImageBoxFuture
      img={img}
      title={title}
      fallBackImg={MovieFallbackImg}
      priority={priority}
      // `responsive` with real `sizes` instead of `intrinsic`: an intrinsic image
      // builds its srcset from the declared 1600 px (w=1920 / w=3840), whatever
      // the slot. The 1600 × 2400 pair below now only sets the 2:3 aspect ratio.
      layout='responsive'
      sizes={POSTER_SLIDER_SIZES}
      objectFit={bannerPosterType === BannerableType.OFFER ? 'contain' : 'cover'}
      width='1600px'
      height='2400px'
      sx={{
        width: '100%',
        borderRadius: pxToRem(20),
        overflow: 'hidden',
        cursor: {
          laptop:
            bannerPosterType === BannerableType.WITHOUT_LINK ? 'default' : 'pointer',
        },
      }}
    />
  );
};

export default PostersSliderItem;
